<ng-container *ngIf="showResetPasswordInfo; else showTokenExpiredInfo">
  <form
    nz-form
    [nzLayout]="'vertical'"
    [formGroup]="form"
    (ngSubmit)="confirmNewPassword()"
    novalidate
    class="max-w-[300px]">
    <nz-form-item>
      <nz-form-label nzFor="password">{{ 'resetPasswordPage.form.password.label' | translate }}</nz-form-label>
      <nz-form-control nzErrorTip="{{ 'resetPasswordPage.form.password.isRequired' | translate }}">
        <input
          nz-input
          placeholder="{{ 'resetPasswordPage.form.password.placeholder' | translate }}"
          formControlName="password"
          name="password"
          type="password"
          id="password" />
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label nzFor="passwordConfirm">{{
        'resetPasswordPage.form.passwordConfirm.label' | translate
      }}</nz-form-label>
      <nz-form-control [nzErrorTip]="confirmErrorTpl">
        <input
          nz-input
          placeholder="{{ 'resetPasswordPage.form.passwordConfirm.placeholder' | translate }}"
          formControlName="passwordConfirm"
          name="passwordConfirm"
          type="password"
          id="passwordConfirm" />
        <ng-template #confirmErrorTpl let-control>
          <ng-container *ngIf="control.hasError('required')">
            {{ 'resetPasswordPage.form.passwordConfirm.isRequired' | translate }}
          </ng-container>
          <ng-container *ngIf="control.hasError('matchValidator')">
            {{ 'resetPasswordPage.form.passwordConfirm.isNotMatch' | translate }}
          </ng-container>
        </ng-template>
      </nz-form-control>
    </nz-form-item>

    <button pm-button [pmType]="'primary'" type="submit" class="mt-[5px] max-xs:mb-[20px] max-md:mb-[20px] max-xs:w-full">
      {{ 'resetPasswordPage.form.confirmButton' | translate }}
    </button>
  </form>
</ng-container>

<ng-template #showTokenExpiredInfo>
  <h2>{{ 'resetPasswordPage.tokenExpired' | translate }}</h2>
</ng-template>
